import React from "react";
import withIconComponent from "../../../withIconComponent";

var AlertHexagonExc = function AlertHexagonExc() {
  return /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    fill: "#DC0A0A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7L4 0H12L16 7L12 14H4L0 7ZM8.75 3H7.25V3.75V7.25V8H8.75V7.25V3.75V3ZM7.25 9V10.5H8.75V9H7.25Z",
    fill: "#DC0A0A"
  }));
};

export default withIconComponent("NucleoSmallUserInterfaceAlertHexagonExc", false)(AlertHexagonExc);